import React from 'react';

import { Svg, SvgProps } from '@lglp/components';

import styles from './ArrowKeyFigureLeaf.module.scss';

const ArrowKeyFigureLeaf: React.FC<ArrowKeyFigureLeafProps> = ({
  className,
  ...rest
}) => {
  return (
    <Svg className={className} viewBox="0 0 110 117" {...rest}>
      <ellipse
        cx="25.025"
        cy="2.807"
        rx="25.025"
        ry="2.807"
        className={styles.cls1}
      />
      <g>
        <g>
          <path
            d="M237.378 31.473c-2.8 17.935-19.193 37.021-.2 61.529a44.953 44.953 0 1 1-39.052-67.272 44.464 44.464 0 0 1 17.481 3.539 2.863 2.863 0 0 0 2.226-5.276A50.156 50.156 0 0 0 198.126 20a50.781 50.781 0 1 0 43.3 77.084c.164-.289 1.133-2.024 1.316-2.441 5.787-12.753 2.233-28.521.417-42.035 6.549 9.323 6.667 24.468 4.965 35.356 18.87-18.785 6.117-42.041-10.746-56.491z"
            className={styles.cls2}
          />
        </g>
      </g>
    </Svg>
  );
};

type ArrowKeyFigureLeafProps = SvgProps;

export default ArrowKeyFigureLeaf;
